<template>
    <div class="small-12 large-9 wrapper-list">
        <h2>Liste des Biens - {{properties.length}} biens trouvés</h2>        
        <div id="list-rendering" class="list">            
            <PropertyElement v-for="property in paginatedData" 
                            v-bind:item="property" 
                            :key="property.link" />
        </div>
        <ListPagination v-if="properties.length > this.itemByPage"
                        :listData="properties" 
                        :itemByPage="itemByPage"
                        :pageNumber="pageNumber"
                        @update-page-number="updatePageNumber"/>
    </div>
</template>

<script>
import PropertyElement from './PropertyElement.vue';
import ListPagination from './ListPagination.vue';

export default {
    name: 'ListProperty',
    components: {
        PropertyElement,
        ListPagination
    },
    data(){
        return {
            pageNumber: 0,  // default to page 0
            itemByPage: 10,
        }
    }, 
    props: {
        properties: Array,
    },
    computed: {        
        paginatedData() {            
            const start = this.pageNumber * this.itemByPage,
                end = start + this.itemByPage;
            return this.properties.slice(start, end);            
        }
    } ,
    methods: {
        updatePageNumber(value) {
            //scroll to top of the list
            let element = document.querySelector(".intro");
            element.scrollIntoView({behavior: "smooth"});
            if(value==='next')
                this.pageNumber++;
            
            if(value==='previous')
                this.pageNumber--;            
        }
    }  
    
}
</script>

<style>
.wrapper-list {
    text-align: left;
}
.wrapper-list h2 {
    background-color: #666;
    color: #fff;
    padding: 5px 10px;
}
.wrapper-list .list {
    padding: 5px 10px;
}
</style>
